import { render, staticRenderFns } from "./profitTable.vue?vue&type=template&id=4efe8538&scoped=true"
import script from "./profitTable.vue?vue&type=script&lang=js"
export * from "./profitTable.vue?vue&type=script&lang=js"
import style0 from "./profitTable.vue?vue&type=style&index=0&id=4efe8538&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4efe8538",
  null
  
)

export default component.exports